import styled from 'styled-components';

interface ICardTitle {
  color?: string;
  width?: string;
}

interface ICardSubtitle {
  children?: string;
}

interface IContentCard {
  hasOneData?: boolean;
  hasThreeData?: boolean;
  flexDirectionRow?: boolean;
  alignCenter?: boolean;
  justifyCenter?: boolean;
}

interface ICardValue {
  hasOneData?: boolean;
  color?: string;
}

interface ICardDivisor {
  isNotActive?: boolean;
}

interface ILabelAndValueContainer {
  alignCenter?: boolean;
  justifyRow?: boolean;
}

export const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.5rem 0 0.5rem;
  background-color: #f5f5f5;
  border-top-right-radius: 0.5rem;
  border-top-left-radius: 0.5rem;
  width: 100%;
  height: auto;
`;

export const OptionContainer = styled.div`
  color: #909090;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 2rem;
  cursor: pointer;
`;

export const TitleAndSubtitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ContentCard = styled.div<IContentCard>`
  display: flex;
  flex-direction: ${(props) => (props.flexDirectionRow ? 'row' : 'column')};
  justify-content: ${(props) =>
    props.justifyCenter ? 'center' : 'space-around'};
  align-items: ${(props) =>
    props.hasOneData || props.alignCenter ? 'center' : 'flex-start'};
  height: 100%;
  width: 100%;
  padding: ${(props) => (props.hasOneData ? '0.5rem 0.5rem' : '0.5rem 1.5rem')};
`;

export const CardTitle = styled.h1<ICardTitle>`
  justify-content: center;
  display: flex;
  margin: 0;
  text-align: center;
  font-size: 1.125rem;
  width: ${(props) => (props.width ? props.width : '11rem')};
  color: ${(props) => props.color};
`;

export const CardSubtitle = styled.h2<ICardSubtitle>`
  display: ${(props) => (props.children !== '' ? 'flex' : 'none')};
  color: #606060;
  font-size: 1rem;
`;

export const LabelAndValueContainer = styled.div<ILabelAndValueContainer>`
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: ${(props) => (props.justifyRow ? 'row' : 'column')};
  padding: 0.25rem 0;
  align-items: ${(props) => (props.alignCenter ? 'center' : 'flex-start')};
`;

export const CardLabel = styled.h1`
  color: ${(props) => (props.color ? props.color : '#606060')};
  min-width: 8rem;
  font-size: 1.5rem;
  margin-bottom: 5px;
`;

export const CardValue = styled.h1<ICardValue>`
  font-size: 1.5rem;
  color: ${(props) => props.color};
`;

export const CardDivisor = styled.div<ICardDivisor>`
  display: ${(props) => (!props.isNotActive ? 'flex' : 'none')};
  width: 1rem;
  height: 100%;
`;
